import Vue from 'vue'
import Vuex from 'vuex'
import nominationsModule from './modules/nominations'
import horseMergeModule from './modules/horseMerge'
import publicDraws from './modules/publicDraws'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    nominations: nominationsModule,
    horseMerge: horseMergeModule,
    publicDraws
  },
  state: {
    invoices: [],
    viewedMember: '',
    childMember: '',
    viewedHorse: '',
    renewMembershipTypes: [],
    selectedRows: [],
    rowsUpdated: false,
    riderStatus: [],
    horseStatus: [],
    products: [],
    discounts: [],
    blocks: [],
    menuOpen: false,
    userToggleOpen: false,
    showExpand: false,
    cartMembers: {},
    listCommittees: {},
    listZones: [],
    listEventTypes: [],
    listDraftStatus: [],
    draft: {},
    placeholder: '',
    member: null,
    listVehiclesTypes: {},
    listVehiclesSizes: []
  },
  mutations: {
    setMember(state, newMember) {
      state.member = newMember
    },
    setCurrentDate(state, currentDate) {
      state.currentDate = currentDate
    },
    updateZones(state, newList) {
      state.listZones = newList
    },
    updateEventTypes(state, newTypes) {
      state.listEventTypes = newTypes
    },
    updatePlaceholder(state, newPlaceholder) {
      state.placeholder = newPlaceholder
    },
    updateDraft(state, newDraft) {
      state.draft = newDraft
    },
    updateDraftStatus(state, newDraftStatus) {
      state.listDraftStatus = newDraftStatus
    },
    updateCommittees(state, newCommittees) {
      state.listCommittees = newCommittees
    },
    updateRiderStatus(state, newList) {
      state.riderStatus = newList
    },
    updateHorseStatus(state, newList) {
      state.horseStatus = newList
    },
    updateProducts(state, newList) {
      state.products = newList
    },
    updateDiscounts(state, newList) {
      state.discounts = newList
    },
    updateInvoices(state, data) {
      state.invoices = data
    },
    updateViewedMember(state, newMember) {
      state.viewedMember = newMember
    },
    updateChildMember(state, newMember) {
      state.childMember = newMember
    },
    updateViewedHorse(state, newHorse) {
      state.viewedHorse = newHorse
    },
    updateSelectedRows(state, newRow) {
      if (state.selectedRows.indexOf(newRow) !== -1) {
        const index = state.selectedRows.indexOf(newRow)
        state.selectedRows.splice(index, 1)
        return
      }
      state.selectedRows.push(newRow)
    },
    setSelectedRows(state, theRows) {
      state.selectedRows = theRows
    },
    deselectAllRows(state) {
      state.selectedRows.splice(0, state.selectedRows.length)
    },
    updateRenewMembershipTypes(state, newRows) {
      state.renewMembershipTypes = newRows
    },
    menuToggle(state) {
      state.menuOpen = !state.menuOpen
      if (state.menuOpen) {
        state.userToggleOpen = false
      }
    },
    rowsUpdatedToggle(state) {
      state.rowsUpdated = !state.rowsUpdated
    },
    userMenuToggle(state) {
      state.userToggleOpen = !state.userToggleOpen
      if (state.userToggleOpen) {
        state.menuOpen = false
      }
    },
    menuClose(state) {
      state.menuOpen = false
    },
    userMenuClose(state) {
      state.userToggleOpen = false
    },
    updateExpand(state, newState) {
      state.showExpand = newState
    },
    updateCartMembers(state, newMembers) {
      state.cartMembers = newMembers
    },
    updateBlocks(state, newBlocks) {
      state.blocks = newBlocks
    },
    setVehiclesTypes(state, vehiclesTypes) {
      state.listVehiclesTypes = vehiclesTypes
    },
    setVehiclesSize(state, vehiclesSize) {
      state.listVehiclesSizes = vehiclesSize
    }
  },
  getters: {
    selectedRows: state => state.selectedRows,
    getRowState: state => id => state.selectedRows.some(theRow => theRow.id === id),
    getCommittees: (state) => {
      let returning = {}
      // eslint-disable-next-line
      if (state.listCommittees.length > 0) {
        returning = state.listCommittees.reduce((resultItem, currentArray) => {
          resultItem[currentArray.id] = `${currentArray.id}: ${currentArray.name}`
          return resultItem
        }, {})
      }
      return returning
    },
    // eslint-disable-next-line eqeqeq
    getCommittee: state => id => state.listCommittees.find(committee => committee.id == id),
    getDraftStatus: state => id => (state.listDraftStatus.some(status => status.id === id) ? state.listDraftStatus.filter(status => status.id === id)[0].name : ''),
    getDraftStatusesAdmin: state => state.listDraftStatus.map((status) => {
      const tempStatus = status
      tempStatus.nameAdmin = tempStatus.name === 'Pending' ? 'Pending (Hidden)' : tempStatus.name === 'Published' ? 'Published (Visible)' : tempStatus.name
      return status
    }),
    getMember: state => state.member,
    getCartMembers: state => state.cartMembers
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js